import { Link } from 'react-router-dom';

export default function CoreServices() {
  const services = [
    {
      icon: 'ri-brain-line',
      title: 'AI · Data R&D',
      description: '복잡한 데이터와 불확실한 기준으로\n의사결정이 어려운 환경을 위해,\n\n4-lab은 AI와 데이터 분석 기술을 기반으로\n공공·기업 연구개발 과제를 수행하고\n실증을 통해 기술의 효과를 검증합니다.',
      color: '#14B8A6',
    },
    {
      icon: 'ri-refresh-line',
      title: 'System Reconstruction',
      description: '노후화되거나 비효율적인 시스템은\n업무 생산성과 데이터 활용을 제한합니다.\n\n4-lab은 기존 시스템을 분석하고\n데이터 기반으로 구조를 재설계하여\n성능과 확장성을 개선합니다.',
      color: '#0D9488',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Custom Solution',
      description: '모든 환경에 동일한 솔루션은\n효과적인 문제 해결이 될 수 없습니다.\n\n4-lab은 고객의 환경과 요구를 분석하여\n맞춤형 솔루션을 설계·개발하고\n현장에서 작동하는 시스템을 제공합니다.',
      color: '#0F766E',
    },
  ];

  return (
    <section className="py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-20 text-center">
          <span className="text-sm font-medium text-[#0F766E] mb-3 block">핵심 서비스</span>
          <h2 className="text-5xl font-bold text-gray-900 leading-tight">
            Core Services
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-[#F0FDFA] rounded-lg p-10 border border-[#99F6E4]/30 hover:border-[#14B8A6]/50 transition-all duration-300 hover:shadow-lg"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-full mb-6"
                style={{ backgroundColor: `${service.color}15` }}
              >
                <i className={`${service.icon} text-3xl`} style={{ color: service.color }}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/services"
            className="inline-flex items-center text-sm font-medium text-[#0D9488] hover:text-[#0F766E] transition-colors cursor-pointer whitespace-nowrap"
          >
            사업 영역 자세히 보기
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
